import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const IconlyHomeIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4309 12.7427C12.4342 12.7427 13.2509 13.5536 13.2509 14.5502V17.1136C13.2509 17.3277 13.4226 17.4994 13.6426 17.5044H15.2309C16.4826 17.5044 17.5001 16.4994 17.5001 15.2644V7.99439C17.4942 7.56939 17.2917 7.16939 16.9442 6.90355L11.4501 2.52189C10.7126 1.93772 9.68091 1.93772 8.94091 2.52355L3.48425 6.90189C3.12341 7.17605 2.92091 7.57605 2.91675 8.00855V15.2644C2.91675 16.4994 3.93425 17.5044 5.18591 17.5044H6.78925C7.01508 17.5044 7.19841 17.3252 7.19841 17.1052C7.19841 17.0569 7.20425 17.0086 7.21425 16.9627V14.5502C7.21425 13.5594 8.02591 12.7494 9.02175 12.7427H11.4309ZM15.2309 18.7544H13.6276C12.7092 18.7327 12.0009 18.0119 12.0009 17.1136V14.5502C12.0009 14.2427 11.7451 13.9927 11.4309 13.9927H9.02591C8.71841 13.9944 8.46425 14.2452 8.46425 14.5502V17.1052C8.46425 17.1677 8.45591 17.2277 8.43841 17.2844C8.34841 18.1094 7.64341 18.7544 6.78925 18.7544H5.18591C3.24508 18.7544 1.66675 17.1886 1.66675 15.2644V8.00272C1.67508 7.17439 2.05675 6.41605 2.71591 5.91689L8.16175 1.54605C9.36091 0.596052 11.0317 0.596052 12.2284 1.54439L17.7134 5.91939C18.3576 6.41022 18.7392 7.16689 18.7501 7.98522V15.2644C18.7501 17.1886 17.1717 18.7544 15.2309 18.7544Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
    </svg>
  );
};

export default IconlyHomeIcon;
